import React from 'react';
import ReactDOM from 'react-dom';

export default class ChoroplethTooltip extends React.Component {

  componentWillMount = () => {
    this.regionName = this.props.regionName;
  };

  componentWillUpdate = (nextProps) => {
    this.regionName = nextProps.regionName || this.props.regionName;
  };

  render() {
    const classList = "ChoroplethTooltip " + (this.props.regionName ? 'active' : 'inactive' )
    return (
      <div className={classList}>
        <div className="tooltip-key">
          {this.props.highlightLabel || "HIGHLIGHTED: "}
        </div>
        <div className="region-name">{this.regionName}</div>
      </div>
    );
  }
}
